// extracted by css-extract-rspack-plugin
export default {"ditherHost":"DitherBackground-module__ditherHost__FDRR5","ditherBackground":"DitherBackground-module__ditherBackground__BqYav"};